import { render, staticRenderFns } from "./az-link.vue?vue&type=template&id=ae5f83ee&scoped=true&"
import script from "./az-link.vue?vue&type=script&lang=js&"
export * from "./az-link.vue?vue&type=script&lang=js&"
import style0 from "./az-link.vue?vue&type=style&index=0&id=ae5f83ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5f83ee",
  null
  
)

export default component.exports